import {
  Smartphone,
  Server,
  Database,
  Network,
  Sparkles,
  Palette,
  CheckCheck,
  Bug,
  Tag,
  Wallet,
  Box,
} from "lucide-react";

export const ICON_MAP = {
  Smartphone,
  Server,
  Database,
  Network,
  Sparkles,
  Palette,
  CheckCheck,
  Bug,
  Tag,
  Wallet,
  Box,
};

export function resolveIcon(key) {
  return ICON_MAP[key] || Tag;
}
